<template>
  <div class="root" v-loading="isLoading">
    <slot name="title"></slot>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Panel",
  props: ["isLoading"],
  data() {
    return {

    };
  },
  methods: {}
};
</script>

<style scoped>
.root {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background: #ebebeb;
  padding: .5rem;
  border-radius: 0.5rem;
}
#app h2 {
  font-size: 1rem;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
